angular.module("leanlaw.core").factory("clientManager", ["$q", "leanLawApi", "accountingService", "userService", "onboardService", "clientMatterManager", function ($q, leanLawApi, accountingService, userService, onboardService, clientMatterManager) {
  var _service = {
    list: listClients,
    create: createClient,
    get: getClient
  };

  ////////////////////////////////////////

  function getClient(id, options) {
    return clientMatterManager.getClient(id, options);
  }
  function createClient(client) {
    return clientMatterManager.createClient(client);
  }
  function listClients(options) {
    return clientMatterManager.listClients(options);
  }
  return _service;
}]);